import { Button } from "@/core/components/ui/button";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { Link } from "react-router-dom";

export function NotFound() {
  const { t } = useTypedTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-4 text-center">
      <img
        src="/flash_pay_logo.png"
        alt={t("app.name")}
        className="h-16 w-auto"
      />
      <p className="font-display text-6xl font-bold text-gradient-accent">
        404
      </p>
      <h1 className="font-display text-2xl font-semibold text-foreground">
        {t("notFoundTitle")}
      </h1>
      <p className="max-w-md text-muted-foreground">
        {t("notFoundDescription")}
      </p>
      <Button asChild>
        <Link to="/">{t("notFoundBackHome")}</Link>
      </Button>
    </div>
  );
}
